import React from 'react';
import { Button } from "flowbite-react";
import { MdRefresh } from "react-icons/md";
import { useSearchContext } from "../utils/Context";
var Reset = function Reset() {
  var _useSearchContext = useSearchContext(),
    reset = _useSearchContext.reset;
  return /*#__PURE__*/React.createElement(Button, {
    color: "blue",
    size: "xs",
    "aria-label": "Reset Search",
    title: "Reset Search",
    onClick: reset
  }, /*#__PURE__*/React.createElement(MdRefresh, {
    className: "md:mr-2 h-4 w-4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden md:inline"
  }, "Reset"));
};
export default Reset;